<template>
  <div>
    <h2>FormValidation</h2>
  </div>
</template>

<script>
  export default {
    name: "FormValidation",
  }
</script>

<style lang="css" scoped>

</style>